import { client } from '../sanity'
import type { WorkflowState } from '@/types/workflow'

/**
 * Fetch incomplete workflow states
 */
export const getIncompleteWorkflows = async (): Promise<WorkflowState[]> => {
  return client.fetch(
    `*[_type == "workflowState" && currentStep < length(steps)] | order(_updatedAt desc) {
      _id,
      _type,
      workflowId,
      currentStep,
      completedSteps,
      data,
      _createdAt,
      _updatedAt
    }`
  )
}
